module.exports = __webpack_public_path__ + "0a973578ab5ba09f01d145684820ad93.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/endless_possibilities/cost_efficiency.png
// module id = 581
// module chunks = 0